import { Log } from '@fanfanlo'
import { initTriggers } from './initTriggers'
import { initActions } from './initActions'

const fileLog = new Log(false, 'initProjectSystem_f')
fileLog.pause = true
fileLog.childrenPaused = true

/**
 * 初始化项目系统
 * 在应用启动时调用，初始化所有 triggers 和 actions
 */
export function initProjectSystem() {
    initTriggers()
    initActions()
}
